import PropTypes from "prop-types";
import style from "./styles";

const PremierSelectorTitle = ({ premierTitle }) => (
  <legend className={style.PremierSelectorTitle}>
    <h2 id="region-title">{premierTitle}</h2>
  </legend>
);

PremierSelectorTitle.propTypes = {
  premierTitle: PropTypes.string.isRequired,
};

export default PremierSelectorTitle;
